import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-back-header',
  standalone: true,
  templateUrl: './back-header.component.html',
  styleUrls: ['./back-header.component.scss'],
  imports: [CommonModule, MatIconModule, TranslateModule],
})
export class BackHeaderComponent {
  @Input() label: string = 'common.buttons.go_back';
  @Input() showLogo: boolean = true;
  @Output() backClicked = new EventEmitter<void>();
}
